const PajNtaubBand = ({ height = 7 }) => (
  <div style={{ width: '100%', overflow: 'hidden', lineHeight: 0, flexShrink: 0 }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={height}
      style={{ width: '100%', display: 'block' }}
    >
      <defs>
        <pattern
          id="paj-ntaub"
          x="0"
          y="0"
          width="80"
          height={height}
          patternUnits="userSpaceOnUse"
        >
          <rect width="80" height={height} fill="#1A2550" />
          <rect width="80" height={height * 0.26} fill="#C94070" />
          <rect y={height * 0.29} width="80" height={height * 0.06} fill="#C8880A" />
          <polygon
            points={`8,${height * 0.4} 11,${height * 0.71} 8,${height} 5,${height * 0.71}`}
            fill="#C94070"
          />
          <polygon
            points={`24,${height * 0.4} 27,${height * 0.71} 24,${height} 21,${height * 0.71}`}
            fill="#C8880A"
          />
          <polygon
            points={`40,${height * 0.4} 43,${height * 0.71} 40,${height} 37,${height * 0.71}`}
            fill="#2A7A5A"
          />
          <polygon
            points={`56,${height * 0.4} 59,${height * 0.71} 56,${height} 53,${height * 0.71}`}
            fill="#A84428"
          />
          <polygon
            points={`72,${height * 0.4} 75,${height * 0.71} 72,${height} 69,${height * 0.71}`}
            fill="#C94070"
          />
          <rect y={height * 0.91} width="80" height={height * 0.09} fill="#C94070" />
        </pattern>
      </defs>
      <rect width="100%" height={height} fill="url(#paj-ntaub)" />
    </svg>
  </div>
);

export default PajNtaubBand;
